var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",staticStyle:{"height":"inherit !important"},attrs:{"fluid":""}},[(_vm.notLicenced)?_c('UnLicencedAccess'):(_vm.BrokenPermit)?_c('UnAuthorizedAccess'):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }